import React, { useState, useCallback, useEffect, useRef } from "react";
import _ from "lodash";
import {
  _getSelectedOption,
  _getBaseUrl,
  _isFirstRender,
  _getCSRFTokenValue,
} from "../utils/helper";
import api from "../utils/api";
import { Loader, Pagination } from "../atoms";
import { FilterDropDown } from "../forms";
import { ContactLibrary } from "../cards";

let INITIAL_VALUES = {
  transitieagenda: [],
  skip: 0,
  take: 6,
  nodeType: "",
  group: "",
};

import StateView from "../utils/StateView";

const TransitieagendaContactpersonen = (props) => {
  const [filterOptions, setFilterOptions] = useState([]);
  const [values, setValues] = useState(INITIAL_VALUES);
  const [posts, setPosts] = useState([]);
  const [totalPosts, setTotalPosts] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoadingFilters, setIsLoadingFilters] = useState(false);
  const [isLoadingPosts, setIsLoadingPosts] = useState(false);
  const [tags, setTags] = useState([]);
  const [isFiltersExpanded, setisFiltersExpanded] = useState(false);

  const isFirstLoad = _isFirstRender();
  const nodeType = props?.data["node-type"] || "";
  const group = props?.data["group"] || "";

  useEffect(() => {
    fetchFilters();

    const urlParams = new URLSearchParams(window.location.search);
    const keyword = decodeURIComponent(urlParams.get("keyword"));
    const topic = decodeURIComponent(urlParams.get("topic"));

    // ATM, from home page, its not possible to have both keyword and topic param at the same time
    if (keyword !== null && keyword !== "" && keyword !== "null") {
      setValues({ ...INITIAL_VALUES, ["keywords"]: [keyword], ["skip"]: 0 });
      addRemoveTags("keywords", keyword, true);
      return;
    }

    if (topic !== null && topic !== "" && topic !== "null") {
      setValues({ ...INITIAL_VALUES, ["topics"]: [topic], ["skip"]: 0 });
      return;
    }

    setValues({ ...INITIAL_VALUES, ["nodeType"]: nodeType, ["group"]: group });

    if (nodeType === "actueel") {
      setValues({ ...INITIAL_VALUES, ["take"]: 12, ["nodeType"]: nodeType });
    }

    fetchPosts();
  }, []);

  useEffect(() => {
    if (!isFirstLoad) {
      fetchPosts();
    }
  }, [values]);

  // Fetch filter options from API
  const fetchFilters = () => {
    setIsLoadingFilters(true);

    api
      .get("/filterlistoptions")
      .then((res) => {
        setIsLoadingFilters(false);
        setFilterOptions(res.data);

        // Check if url has topic param
        const urlParams = new URLSearchParams(window.location.search);
        const topic = decodeURIComponent(urlParams.get("topic"));

        if (topic !== null && topic !== "" && topic !== "null") {
          addRemoveTags("topics", topic, true);
        }
      })
      .catch(() => {
        setIsLoadingFilters(false);
      });
  };

  // Fetch Library posts from API
  const fetchPosts = async () => {
    setIsLoadingPosts(true);

    const csrfToken = await _getCSRFTokenValue();
    const fields = values;
    api
      .post("/searchandfilter", fields, {
        headers: {
          "X-CSRF-Token": csrfToken,
        },
      })
      .then((res) => {
        // console.log("post results", res);
        setIsLoadingPosts(false);
        setPosts(res.data.posts);
        setTotalPosts(res.data.totalNodes);
      })
      .catch(() => {
        setIsLoadingPosts(false);
      });
  };

  const updateFilters = (key, value) => {
    let filters = { ...values, [key]: value, skip: 0 };

    setCurrentPage(1);
    setValues(filters);
  };

  const addRemoveTags = (filter, value, addRemove) => {
    let temp = [...tags];

    // True === add
    if (addRemove) {
      temp.push({
        filter,
        value,
      });
    } else {
      temp = temp.filter((item) => {
        return !(item.filter === filter && item.value === value);
      });
    }

    setTags(temp);
  };

  const onFilterChanged = (filter, value, checked) => {
    // console.log("onFilterChanged", filter, value, checked);

    let updatedValue = [...values[filter]];

    if (checked) {
      addRemoveTags(filter, value, true);
      updatedValue.push(value);
    } else {
      addRemoveTags(filter, value, false);
      updatedValue = updatedValue.filter((item) => {
        return item !== value;
      });
    }

    updateFilters(filter, updatedValue);
    // setValues({ ...values, [filter]: updatedValue, skip: 0 });
  };

  //CLEAR ALL FILTER BUTTON
  const clearFilters = () => {
    setValues({
      ...INITIAL_VALUES,
      nodeType: values.nodeType,
      group: values.group,
    });
    setTags([]);
  };

  const navigatePage = (goNext) => {
    let page;

    if (goNext) {
      page = currentPage + 1;
    } else {
      page = currentPage - 1;
    }

    setValues({ ...values, skip: (page - 1) * values.take });
    setCurrentPage(page);
  };

  const labelsOnly =
    filterOptions?.transitieagenda?.map((item) => item["label"]) || [];

  const results = [];

  labelsOnly.forEach((label) => {
    const filteredPosts = posts.filter((post) =>
      post.transitieagenda.includes(label)
    );

    if (filteredPosts.length > 0) {
      results.push({ label, posts: filteredPosts });
    }
  });

  // SHOW ONLY FIVE THEN REST NEXT PAGE

  // Adjusting for pagination
  // const postsPerPage = 5;
  // const postsPerSlide = 20;

  // const paginatedResults = results.map(result => {
  //   const totalPostsForLabel = result.posts.length;
  //   const startIndex = (currentPage - 1) * postsPerPage;
  //   const endIndex = startIndex + postsPerPage;
  //   const paginatedPosts = result.posts.slice(startIndex, endIndex);

  //   return {
  //     ...result,
  //     paginatedPosts,
  //     totalPostsForLabel
  //   };
  // });

  // Check if any category has more than 5 posts
  // const hasMoreThan5Posts = paginatedResults.some(result => result.totalPostsForLabel > 5);

  // let sliderTotal = 0;

  // if (hasMoreThan5Posts) {
  //   const categoryWithMostPosts = paginatedResults.reduce((max, result) =>
  //     result.totalPostsForLabel > max.totalPostsForLabel ? result : max
  //     , { totalPostsForLabel: 0 });

  //   const mostPostsCategoryTotal = categoryWithMostPosts.totalPostsForLabel || 0;

  //   console.log("totalMostPosts", mostPostsCategoryTotal);

  //   sliderTotal = Math.ceil(mostPostsCategoryTotal / postsPerPage);

  // }
  // else {
  //   sliderTotal = 1;
  // }

  // END SHOW ONLY FIVE THEN REST NEXT PAGE

  // Show all posts without pagination
  const allPosts = results.map((result) => ({
    ...result,
    paginatedPosts: result.posts, // Include all posts
    totalPostsForLabel: result.posts.length,
  }));

  // Determine the number of slides based on the total posts
  // const maxPostsCategory = allPosts.reduce((max, result) =>
  //   result.totalPostsForLabel > max.totalPostsForLabel ? result : max
  //   , { totalPostsForLabel: 0 });

  // sliderTotal = Math.ceil(maxPostsCategory.totalPostsForLabel / postsPerSlide);

  console.log("All Posts:", allPosts);
  // console.log("Slider Total:", sliderTotal);

  return (
    <React.Fragment>
      {!isLoadingFilters && (
        <div className="container my-10">
          <div className="border border-black md:border-none px-4 md:p-0">
            <div
              className="h-[70px] pr-4 md:hidden flex items-center justify-between cursor-pointer"
              onClick={() => {
                setisFiltersExpanded(!isFiltersExpanded);
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  setisFiltersExpanded(!isFiltersExpanded);
                }
              }}
              aria-expanded={isFiltersExpanded ? "true" : "false"}
              aria-controls="filters-section-transitieagenda"
              tabIndex={0}
              role="button"
            >
              <span className="text-sm lg:text-base">Filters</span>
              <img
                src={`${_getBaseUrl("src/assets/icon-download.svg", true)}`}
                alt=""
                className={`filter brightness-0 ${isFiltersExpanded ? "rotate-180" : ""
                  }`}
              />
            </div>

            <div
              id="filters-section-transitieagenda"
              className={`${isFiltersExpanded
                ? "opacity-100"
                : "h-0 opacity-0 md:h-auto md:opacity-100"
                } md:block`}
            >
              <div className="pb-4 grid gap-5 lg:grid-cols-4">
                <React.Fragment>
                  <FilterDropDown
                    placeholder="transitieagenda's"
                    filter="transitieagenda"
                    options={filterOptions.transitieagenda}
                    onChange={onFilterChanged}
                    value={values.transitieagenda}
                    trayClass="w-full mt-2 md:left-[unset] md:right-0 xl:right-[unset] xl:left-0"
                    trayBodyClass="max-h-[500px] overflow-y-auto"
                  />
                </React.Fragment>
              </div>
            </div>
          </div>
        </div>
      )}
      {tags.length > 0 && (
        <div className="container">
          <h2 className="text-lg scale-text-150:text-xl scale-text-200:text-2xl mb-3 font-semibold">
            Toegepaste filters
          </h2>
          <div className="filter-tags--wrapper flex flex-wrap gap-1">
            {tags.map((item) => {
              // Tags for topics
              return (
                <button
                  className="filter-tag"
                  tabIndex={0}
                  onClick={() =>
                    onFilterChanged(item.filter, item.value, false)
                  }
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      onFilterChanged(item.filter, item.value, false);
                    }
                  }}
                >
                  <span>
                    {
                      _getSelectedOption(
                        filterOptions[item.filter],
                        item.value,
                        true
                      ).label
                    }
                  </span>
                  <div className="filter-tag--remove"></div>
                </button>
              );
            })}

            <button
              className="filter-tag clear cursor-pointer"
              onClick={() => clearFilters()}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  clearFilters();
                }
              }}
              tabIndex={0}
              role="button"
            >
              <span>reset filter</span>
              <div className="filter-tag--remove"></div>
            </button>
          </div>
        </div>
      )}
      <div className="mt-8">
        <div className="container">
          <div className="my-8">
            {isLoadingPosts && <Loader class="mb-8" />}
            {_.isArray(posts) && posts.length > 0 ? (
              <React.Fragment>
                {/* <div className="text-center text-xl md:text-2xl lg:text-3xl mb-8 md:mb-4">
                  {totalPosts} resultaten
                </div> */}

                {/* <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-10 py-8">
                  {posts.map((post) => (
                    <ContactLibrary data={post} />
                  ))}
                </div> */}

                {/* {BouwPosts.length > 0 && (
                  <>
                    <h3 className="h3 font-semibold text-cirGold">Bouw</h3>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-10 py-8">
                      {BouwPosts.map(post => (
                        <ContactLibrary key={post.id} data={post} />
                      ))}
                    </div>
                  </>
                )} */}

                {allPosts.map(
                  (result) =>
                    result.paginatedPosts.length > 0 && (
                      <section key={result.label}>
                        <h2 className="h3 font-semibold text-cirGold">
                          {result.label}
                        </h2>
                        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-10 pt-4 pb-8">
                          {result.paginatedPosts.map((post) => (
                            <ContactLibrary
                              key={post.id}
                              data={post}
                              nodeType={nodeType}
                            />
                          ))}
                        </div>
                      </section>
                    )
                )}

                {/* <div className="slider-control flex gap-4 md:gap-8 items-center justify-center my-12">
                  <button
                    className={`prev rotate-180 nav-icon-after-white text-base gap-7 align-bottom w-full md:w-auto max-w-[100px] py-2.5 px-6 rounded-full bg-black text-white border-black border hover:bg-white hover:text-cirBlack relative flex items-center justify-center cursor-pointer ${currentPage <= 1 && "opacity-70 pointer-events-none"}`}
                    onClick={() => navigatePage(false)}
                  ></button>
                  <div className="count-wrap relative">
                    {currentPage} van {sliderTotal}
                  </div>
                  <button
                    className={`next nav-icon-after-white text-base gap-7 align-bottom w-full md:w-auto max-w-[100px] py-2.5 px-6 rounded-full bg-black text-white border-black border hover:bg-white hover:text-cirBlack relative flex items-center justify-center cursor-pointer ${currentPage >= sliderTotal && "opacity-70 pointer-events-none"}`}
                    onClick={() => navigatePage(true)}
                  ></button>
                </div> */}
              </React.Fragment>
            ) : isLoadingPosts ? null : (
              <p className="text-center">Er zijn geen berichten beschikbaar.</p>
            )}
          </div>
        </div>
      </div>
      {/* {<StateView title="values" values={values} floating />} */}
      {/* {<StateView title="tags" values={tags} class="bottom-4 left-4 right-[unset]" floating />} */}
      {/* {<StateView title="posts" values={posts} class="top-4 right-4" floating collapsed/>} */}
      {/* {<StateView title="total posts" values={totalPosts} class="top-4 bottom-[unset] left-4 right-[unset]" floating />} */}
      {/* {<StateView title="filters" values={filterOptions} class="bottom-4 right-96 max-h-[90vh] overflow-y-auto" floating />} */}
      {(isLoadingPosts || isLoadingFilters) && <Loader />}
    </React.Fragment>
  );
};

export default TransitieagendaContactpersonen;
